import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

type UserAccessStatePanelProps = {
  header?: ReactNode;
  children: ReactNode;
  minHeight?: number;
};

export function UserAccessStatePanel({ header, children, minHeight = 0 }: UserAccessStatePanelProps) {
  return (
    <Stack width="100%" height="100%" minHeight={minHeight} bgcolor="background.paper">
      {header}
      {children}
    </Stack>
  );
}
